import React,{useState} from 'react'
import { Link } from 'react-router-dom'
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';

function valuetext(value) {
  return `${value}°C`;
}
function Filters(props) {
  const { heading, options, handleFiltering,maxRange,minRange,dis ,intitialrange} = props
  const [value2, setValue2] = useState(intitialrange);
  const minDistance = dis;

  const handleChange2 = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], maxRange - minDistance);
        setValue2([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        setValue2([clamped - minDistance, clamped]);
      }
    } else {
      setValue2(newValue);
    }
    handleFiltering("Price Range",newValue);
  };

  return (
    <div className="">
      <li class="nav-item mx-4 dropdown">
        <a class="nav-link dropdown-toggle grey-text border border-info rounded" id="organizationMenuLink" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {heading}
        </a>
        <div class={`dropdown-menu dropdown-primary ${heading === "Price Range" && "px-2"} teal lighten-1 `} aria-labelledby="organizationMenuLink">
          {heading === "Price Range" &&
          <Box sx={{ width: 300 }}>
            <Slider
              getAriaLabel={() => 'Minimum distance shift'}
              value={value2}
              onChange={handleChange2}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              disableSwap
              max={maxRange}
              min={minRange}
              classname="m-2"
              color='secondary'
            />
            </Box>}
          {heading !== "Price Range" && options.map((option) => {
            return <div class="dropdown-item " style={{ cursor: "pointer" }} onClick={() => handleFiltering(heading, option)}  >{option}</div>

          })}
        </div>
      </li>
    </div>
  )
}

export default Filters